// --safety-color: #dcc132db;

// 	--equipment-color: #dc8823db;

// 	--operation-color: #076407b5;

// 	--maintenance-color: #0d6efda8;

// 	--troubleshooting-color: #920e0ead;

// 	--appendix-color: #4c1b7dd1;

const SearchData = [
	{
		section: 'Safety',
		page: 'Safety Overview',
		tab: 'Safety Introduction',
		link: '/smart-inspect/warren/safety/safety-overview/?tab=Safety Overview',
		color: '#dcc132db',
	},
	{
		section: 'Safety',
		page: 'Safety Overview',
		tab: 'Notices',
		link: '/smart-inspect/warren/safety/safety-overview/?tab=Notices',
		color: '#dcc132db',
	},
	{
		section: 'Safety',
		page: 'Safety Overview',
		tab: 'General Safety',
		link: '/smart-inspect/warren/safety/safety-overview/?tab=General Safety',
		color: '#dcc132db',
	},
	{
		section: 'Safety',
		page: 'Safety Overview',
		tab: 'Personal Safety',
		link: '/smart-inspect/warren/safety/safety-overview/?tab=Personal Safety',
		color: '#dcc132db',
	},
	{
		section: 'Safety',
		page: 'Safety Overview',
		tab: 'Work Area Safety',
		link: '/smart-inspect/warren/safety/safety-overview/?tab=Work Area Safety',
		color: '#dcc132db',
	},
	{
		section: 'Safety',
		page: 'Safety Overview',
		tab: 'LOTO',
		link: '/smart-inspect/warren/safety/safety-overview/?tab=LOTO',
		color: '#dcc132db',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Safety',
		page: 'Control Safety',
		tab: 'Electrical Safety',
		keywords: ['arc fault'],
		link: '/smart-inspect/warren/safety/control-safety/?tab=Electrical Safety',
		color: '#dcc132db',
	},
	{
		section: 'Safety',
		page: 'Control Safety',
		tab: 'Mechanical Safety',
		link: '/smart-inspect/warren/safety/control-safety/?tab=Mechanical Safety',
		color: '#dcc132db',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Safety',
		page: 'Safety Devices',
		tab: 'Emergency Stop Pushbuttons',
		link: '/smart-inspect/warren/safety/safety-devices',
		color: '#dcc132db',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Safety',
		page: 'Equipment Lockout',
		tab: 'Equipment Lockout',
		link: '/smart-inspect/warren/safety/equipment-lockout',
		color: '#dcc132db',
	},
	{
		section: 'Safety',
		page: 'Energy Sources',
		tab: 'PDP Main Power Disconnect',
		keywords: ['PDP Main Power Disconnect'],
		link: '/smart-inspect/warren/safety/energy-sources',
		color: '#dcc132db',
	},
	///////////////////////////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Equipment',
		page: 'Equipment Overview',
		tab: 'SMARTInspect Layout',
		link: '/smart-inspect/warren/equipment/equipment-overview/?tab=SMARTInspect Layout',
		color: '#dc8823db',
	},
	{
		section: 'Equipment',
		page: 'Equipment Overview',
		tab: 'Sequence of Operations',
		link: '/smart-inspect/warren/equipment/equipment-overview/?tab=Sequence of Operations',
		color: '#dc8823db',
	},
	{
		section: 'Equipment',
		page: 'Assemblies',
		tab: 'Inspection Frame Assembly',
		link: '/smart-inspect/warren/equipment/assemblies/?tab=Inspection Frame Assembly',
		color: '#dc8823db',
	},
	{
		section: 'Equipment',
		page: 'Assemblies',
		tab: 'Camera Mounting Assemblies',
		link: '/smart-inspect/warren/equipment/assemblies/?tab=Camera Mounting Assemblies',
		color: '#dc8823db',
	},
	{
		section: 'Equipment',
		page: 'Assemblies',
		tab: 'Camera Assemblies',
		link: '/smart-inspect/warren/equipment/assemblies/?tab=Camera Assemblies',
		color: '#dc8823db',
	},
	{
		section: 'Equipment',
		page: 'Assemblies',
		tab: 'Lighting Assemblies',
		link: '/smart-inspect/warren/equipment/assemblies/?tab=Lighting Assemblies',
		color: '#dc8823db',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Equipment',
		page: 'Electrical Panels',
		tab: 'PDP',
		link: '/smart-inspect/warren/equipment/electrical-panels/?tab=PDP',
		color: '#dc8823db',
	},
	{
		section: 'Equipment',
		page: 'Electrical Panels',
		tab: 'Transformer Stand',
		link: '/smart-inspect/warren/equipment/electrical-panels/?tab=Transformer Stand',
		color: '#dc8823db',
	},
	{
		section: 'Equipment',
		page: 'Electrical Panels',
		tab: 'PAC',
		link: '/smart-inspect/warren/equipment/electrical-panels/?tab=PAC',
		color: '#dc8823db',
	},
	{
		section: 'Equipment',
		page: 'Electrical Panels',
		tab: 'Server Panel',
		link: '/smart-inspect/warren/equipment/electrical-panels/?tab=Server Panel',
		color: '#dc8823db',
	},
	{
		section: 'Equipment',
		page: 'Electrical Panels',
		tab: 'Trigger Panels',
		link: '/smart-inspect/warren/equipment/electrical-panels/?tab=Trigger Panels',
		color: '#dc8823db',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Equipment',
		page: 'System Control',
		tab: 'HMI',
		link: '/smart-inspect/warren/equipment/system-control/?tab=HMI',
		color: '#dc8823db',
	},
	{
		section: 'Equipment',
		page: 'System Control',
		tab: 'Buttons and Indicators',
		link: '/smart-inspect/warren/equipment/system-control/?tab=Buttons and Indicators',
		color: '#dc8823db',
	},
	{
		section: 'Equipment',
		page: 'System Control',
		tab: 'Inspection Monitor',
		link: '/smart-inspect/warren/equipment/system-control/?tab=Inspection Monitor',
		color: '#dc8823db',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Equipment',
		page: 'Part / Skid Detect',
		tab: 'Encoder Wheel Line Trackers',
		link: '/smart-inspect/warren/equipment/part-detect/?tab=Encoder Wheel Line Trackers',
		color: '#dc8823db',
	},
	{
		section: 'Equipment',
		page: 'Part / Skid Detect',
		tab: 'AB Skid Detect Switch Bracket',
		link: '/smart-inspect/warren/equipment/part-detect/?tab=AB Skid Detect Switch Bracket',
		color: '#dc8823db',
	},
	{
		section: 'Equipment',
		page: 'Part / Skid Detect',
		tab: 'Part Detect Photoeye Assembly',
		link: '/smart-inspect/warren/equipment/part-detect/?tab=Part Detect Photoeye Assembly',
		color: '#dc8823db',
	},
	{
		section: 'Equipment',
		page: 'Part / Skid Detect',
		tab: 'Door Open Laser Assembly',
		link: '/smart-inspect/warren/equipment/part-detect/?tab=Door Open Laser Assembly',
		color: '#dc8823db',
	},
	///////////////////////////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Maintenance',
		page: 'Maintenance Overview',
		tab: 'Maintenance Overview',
		link: '/smart-inspect/warren/maintenance/maintenance-overview/',
		color: '#0d6efda8',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Maintenance',
		page: 'Maintenance Safety',
		tab: 'General Maintenance Safety',
		link: '/smart-inspect/warren/maintenance/maintenance-safety/?tab=General Maintenance Safety',
		color: '#0d6efda8',
	},
	{
		section: 'Maintenance',
		page: 'Maintenance Safety',
		tab: 'Mechanical Maintenance Safety',
		link: '/smart-inspect/warren/maintenance/maintenance-safety/?tab=Mechanical Maintenance Safety',
		color: '#0d6efda8',
	},
	{
		section: 'Maintenance',
		page: 'Maintenance Safety',
		tab: 'Electrical Maintenance Safety',
		link: '/smart-inspect/warren/maintenance/maintenance-safety/?tab=Electrical Maintenance Safety',
		color: '#0d6efda8',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Maintenance',
		page: 'Maintenance Lockout',
		tab: 'Maintenance Lockout',
		link: '/smart-inspect/warren/maintenance/maintenance-lockout/?tab=Maintenance Lockout',
		color: '#0d6efda8',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Maintenance',
		page: 'Maintenance Lockout',
		tab: 'Maintaining Safety Features',
		link: '/smart-inspect/warren/maintenance/maintenance-lockout/?tab=Maintaining Safety Features',
		color: '#0d6efda8',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Maintenance',
		page: 'Preventive Maintenance',
		tab: 'Preventive Maintenance',
		link: '/smart-inspect/warren/maintenance/preventive-maintenance',
		color: '#0d6efda8',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Maintenance',
		page: 'OEM Maintenance',
		tab: 'OEM Maintenance',
		link: '/smart-inspect/warren/maintenance/oem-maintenance',
		color: '#0d6efda8',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Maintenance',
		page: 'Maintenance Procedures',
		tab: 'ALLIED Camera Replacement',
		link: '/smart-inspect/warren/maintenance/maintenance-procedures/?tab=ALLIED Camera Replacement',
		color: '#0d6efda8',
	},
	{
		section: 'Maintenance',
		page: 'Maintenance Procedures',
		tab: 'Channel Board Replacement',
		link: '/smart-inspect/warren/maintenance/maintenance-procedures/?tab=Channel Board Replacement',
		color: '#0d6efda8',
	},
	{
		section: 'Maintenance',
		page: 'Maintenance Procedures',
		tab: 'Trigger Board Replacement',
		link: '/smart-inspect/warren/maintenance/maintenance-procedures/?tab=Trigger Board Replacement',
		color: '#0d6efda8',
	},
	{
		section: 'Maintenance',
		page: 'Maintenance Procedures',
		tab: 'Light Arch Replacement',
		link: '/smart-inspect/warren/maintenance/maintenance-procedures/?tab=Light Arch Replacement',
		color: '#0d6efda8',
	},
	{
		section: 'Maintenance',
		page: 'Maintenance Procedures',
		tab: 'Lights 1-8 Replacement',
		link: '/smart-inspect/warren/maintenance/maintenance-procedures/?tab=Lights 1-8 Replacement',
		color: '#0d6efda8',
	},
	{
		section: 'Maintenance',
		page: 'Maintenance Procedures',
		tab: 'Lights 2-5 Replacement',
		link: '/smart-inspect/warren/maintenance/maintenance-procedures/?tab=Lights 2-5 Replacement',
		color: '#0d6efda8',
	},
	{
		section: 'Maintenance',
		page: 'Maintenance Procedures',
		tab: 'Double Wide Lights Replacement',
		link: '/smart-inspect/warren/maintenance/maintenance-procedures/?tab=Double Wide Lights Replacement',
		color: '#0d6efda8',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Maintenance',
		page: 'Machine Ledgers',
		tab: 'Machine Ledgers',
		link: '/smart-inspect/warren/maintenance/machine-ledgers',
		color: '#0d6efda8',
	},
	///////////////////////////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Troubleshooting',
		page: 'Troubleshooting Overview',
		tab: 'Troubleshooting Overview',
		link: '/smart-inspect/warren/troubleshooting/troubleshoot-overview/?tab=Troubleshooting Overview',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Troubleshooting Overview',
		tab: 'Troubleshooting Guidelines',
		link: '/smart-inspect/warren/troubleshooting/troubleshoot-overview/?tab=Troubleshooting Guidelines',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Troubleshooting Overview',
		tab: 'Experience',
		link: '/smart-inspect/warren/troubleshooting/troubleshoot-overview/?tab=Experience',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Troubleshooting Overview',
		tab: 'Step-by-Step Approach',
		link: '/smart-inspect/warren/troubleshooting/troubleshoot-overview/?tab=Step-by-Step Approach',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Troubleshooting Overview',
		tab: 'Intermittent Failures',
		link: '/smart-inspect/warren/troubleshooting/troubleshoot-overview/?tab=Intermittent Failures',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Troubleshooting Overview',
		tab: 'Root Cause',
		link: '/smart-inspect/warren/troubleshooting/troubleshoot-overview/?tab=Root Cause',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Troubleshooting Overview',
		tab: 'HMI',
		link: '/smart-inspect/warren/troubleshooting/troubleshoot-overview/?tab=HMI',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Troubleshooting Overview',
		tab: 'Fault Recovery Procedure',
		link: '/smart-inspect/warren/troubleshooting/troubleshoot-overview/?tab=Fault Recovery Procedure',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Troubleshooting Overview',
		tab: 'Troubleshooting Process',
		link: '/smart-inspect/warren/troubleshooting/troubleshoot-overview/?tab=Troubleshooting Process',
		color: '#920e0ead',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Troubleshooting',
		page: 'Mechanical Troubleshooting',
		tab: 'Mechanical Troubleshooting',
		link: '/smart-inspect/warren/troubleshooting/mechanical-troubleshooting',
		color: '#920e0ead',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Troubleshooting',
		page: 'Electrical Troubleshooting',
		tab: 'Electrical Troubleshooting Overview',
		link: '/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Electrical Troubleshooting Overview',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Electrical Troubleshooting',
		tab: 'Electrical Troubleshooting Procedure',
		link: '/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Electrical Troubleshooting Procedure',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Electrical Troubleshooting',
		tab: 'Sequence Stops',
		link: '/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Sequence Stops',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Electrical Troubleshooting',
		tab: 'Repairing Sensors',
		link: '/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Repairing Sensors',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Electrical Troubleshooting',
		tab: 'Non-Actuating Problems',
		link: '/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Non-Actuating Problems',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Electrical Troubleshooting',
		tab: 'Programmable Logic Controller (PLC)',
		link: '/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Programmable Logic Controller (PLC)',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Electrical Troubleshooting',
		tab: 'PLC Inputs',
		link: '/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=PLC Inputs',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Electrical Troubleshooting',
		tab: 'PLC Outputs',
		link: '/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=PLC Outputs',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Electrical Troubleshooting',
		tab: 'PLC Processor',
		link: '/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=PLC Processor',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Electrical Troubleshooting',
		tab: 'Allen Bradley GuardLogix',
		link: '/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Allen Bradley GuardLogix',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Electrical Troubleshooting',
		tab: 'Control Panel',
		link: '/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Control Panel',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Electrical Troubleshooting',
		tab: 'Proximity / Limit Switch',
		link: '/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Proximity / Limit Switch',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Electrical Troubleshooting',
		tab: 'Electrical Device Inspection',
		link: '/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Electrical Device Inspection',
		color: '#920e0ead',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Troubleshooting',
		page: 'OEM Troubleshooting',
		tab: 'OEM  Equipment Troubleshooting',
		link: '/smart-inspect/warren/troubleshooting/oem-troubleshooting',
		color: '#920e0ead',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Troubleshooting',
		page: 'SMARTInspect Troubleshooting',
		tab: 'SMARTInspect Troubleshooting Overview',
		link: '/smart-inspect/warren/troubleshooting/smart-inspect-troubleshooting/?tab=SMARTInspect Troubleshooting Overview',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'SMARTInspect Troubleshooting',
		tab: "PowerPaint 'Rendering' Issues",
		link: '/smart-inspect/warren/troubleshooting/smart-inspect-troubleshooting/?tab=PowerPaint Rendering Issues',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'SMARTInspect Troubleshooting',
		tab: "'Missing' Configuration Files",
		link: '/smart-inspect/warren/troubleshooting/smart-inspect-troubleshooting/?tab=Missing Configuration Files',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'SMARTInspect Troubleshooting',
		tab: 'SQL Server Exceptions',
		link: '/smart-inspect/warren/troubleshooting/smart-inspect-troubleshooting/?tab=SQL Server Exceptions',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'SMARTInspect Troubleshooting',
		tab: 'Recovering From Fault State',
		link: '/smart-inspect/warren/troubleshooting/smart-inspect-troubleshooting/?tab=Recovering from Fault State',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'SMARTInspect Troubleshooting',
		tab: 'Finesse Deck Issues',
		link: '/smart-inspect/warren/troubleshooting/smart-inspect-troubleshooting/?tab=Finesse Deck Issues',
		color: '#920e0ead',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Troubleshooting',
		page: 'Hardware Troubleshooting',
		tab: 'ALLIED Camera Troubleshooting',
		link: '/smart-inspect/warren/troubleshooting/hardware-troubleshooting/?tab=ALLIED Camera Troubleshooting',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Hardware Troubleshooting',
		tab: 'No LED / Channel Board Power',
		link: '/smart-inspect/warren/troubleshooting/hardware-troubleshooting/?tab=No LED / Channel Board Power',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Hardware Troubleshooting',
		tab: 'LED Board Not Illuminated',
		link: '/smart-inspect/warren/troubleshooting/hardware-troubleshooting/?tab=LED Board Not Illuminated',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Hardware Troubleshooting',
		tab: 'Suspected LED Trigger Problem',
		link: '/smart-inspect/warren/troubleshooting/hardware-troubleshooting/?tab=Suspected LED Trigger Problem',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Hardware Troubleshooting',
		tab: 'No Trigger Board Power',
		link: '/smart-inspect/warren/troubleshooting/hardware-troubleshooting/?tab=No Trigger Board Power',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Hardware Troubleshooting',
		tab: 'Suspected Encoder Signal Problem',
		link: '/smart-inspect/warren/troubleshooting/hardware-troubleshooting/?tab=Suspected Encoder Signal Problem',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Hardware Troubleshooting',
		tab: 'Suspected Part Detect Signal Problem',
		link: '/smart-inspect/warren/troubleshooting/hardware-troubleshooting/?tab=Suspected Part Detect Signal Problem',
		color: '#920e0ead',
	},
	{
		section: 'Troubleshooting',
		page: 'Hardware Troubleshooting',
		tab: 'Suspected Laser Photoeye Signal Problem',
		link: '/smart-inspect/warren/troubleshooting/hardware-troubleshooting/?tab=Suspected Laser Photoeye Signal Problem',
		color: '#920e0ead',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Drawings',
		page: 'Mechanical Drawings',
		tab: 'Mechanical Drawings',
		link: '/smart-inspect/warren/drawings/?tab=Mechanical Drawings',
		color: '#920e0ead',
	},
	{
		section: 'Drawings',
		page: 'Electrical Drawings',
		tab: 'Electrical Drawings',
		link: '/smart-inspect/warren/drawings/?tab=Electrical Drawings',
		color: '#920e0ead',
	},
	{
		section: 'Drawings',
		page: 'Vendor Drawings',
		tab: 'Vendor Drawings',
		link: '/smart-inspect/warren/drawings/?tab=Vendor Drawings',
		color: '#920e0ead',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Appendix',
		page: '',
		tab: 'Appendix',
		link: '/smart-inspect/warren/appendix',
		color: '#000',
	},
	{
		section: 'Appendix',
		page: '',
		tab: 'Training Documents',
		link: '/smart-inspect/warren/training-docs',
		color: '#000',
	},
	///////////////////////////////////////////////////////////////////////////////////
	{
		section: 'Operation',
		tab: 'Introduction to SMARTInspect',
		title: 'Introduction to SMARTInspect',
		modal: 'intro',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Configuration File Setup',
		modal: 'config-setup',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Manual Stop / Start Procedure',
		modal: 'start-stop',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Server Power Shutdown / Setup',
		modal: 'startup-shutdown',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Plugin Menu',
		modal: 'plugin-menu',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Service Sidebar',
		modal: 'service-sidebar',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Cell Overview',
		modal: 'cell-overview',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Side-by-Side View',
		modal: 'horizontal-layout',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Top-Bottom View',
		modal: 'vertical-layout',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Job Queue',
		modal: 'job-queue',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Camera Status',
		modal: 'camera-status',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Service Process Viewer',
		modal: 'service-process-viewer',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Server Process Monitor',
		modal: 'service-process-monitor',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Service Monitor',
		modal: 'service-monitor',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Scans',
		modal: 'scans',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Scan Rate',
		modal: 'scan-rate',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Defects',
		modal: 'defects',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Defect Detail',
		modal: 'defect-detail',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Faults',
		modal: 'faults',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Offline Services',
		modal: 'offline-services',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Change Log',
		modal: 'change-log',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'QVS Fault Viewer',
		modal: 'QVS-fault-viewer',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'QVS Scan History',
		modal: 'QVS-scan-history',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Hotspot Editor',
		modal: 'hotspot',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Style Setup',
		modal: 'style-setup',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Plant Color Family Setup',
		modal: 'plant-color',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Plant Camera Family Override',
		modal: 'plant-camera-override',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'JSON Editor',
		modal: 'json-editor',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Defect Heat Map',
		modal: 'defect-map',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Network Diagnostic',
		modal: 'network-diagnostic',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'PLC I/O',
		modal: 'plc-io',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Baseline Setup',
		modal: 'baseline-setup',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Calculator',
		modal: 'calculator',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Fault Viewer',
		modal: 'fault-viewer',
		color: 'green',
	},
	{
		section: 'Operation',
		tab: 'Recovery Screen',
		modal: 'recovery-screen',
		color: 'green',
	},
];

export default SearchData;
